/* js bridge 协议 path */
export const LIGHT_TEMPLATELIST = 'light_templatelist';
export const SHARE_H5 = 'share_h5';
export const INIT_SHAER = 'init_share';

// 模板预览
export const TEMPLATE_PREVIEW = 'template_preview';

// 轻拍(灵感拍摄)
export const QINGPAI = 'qingpai';

// 手动编辑
export const MANUAL_EDIT = 'manual_edit';

// 一键成片
export const AI_EDIT = 'ai_edit';

// 设备管理
export const DEVICE_MANAGEMENT = 'device_management';

// 拍摄引导
export const SHOOT_GUIDE = 'shoot_guide';
